import { render, staticRenderFns } from "./draggable-popup.vue?vue&type=template&id=1d9a23bf&scoped=true&"
import script from "./draggable-popup.vue?vue&type=script&lang=js&"
export * from "./draggable-popup.vue?vue&type=script&lang=js&"
import style0 from "./draggable-popup.vue?vue&type=style&index=0&id=1d9a23bf&scoped=true&lang=css&"
import style1 from "./draggable-popup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a23bf",
  null
  
)

export default component.exports